import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ShkDate } from 'shk-date';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { enduserInterface } from 'src/app/util/interfaces/enduser';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class RequestChangePlanService {
	private changePlanUrl = environment.baseApiUrl + 'request/{idRequest}/changePlan';
	private ciChangePlanUrl = environment.baseApiUrl + 'request/{idRequest}/changePlan/cis';

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	getChangePlan(idRequest: string): Observable<any> {
		const changePlanUrl = this.changePlanUrl.replace('{idRequest}', idRequest);
		return this.http.get(changePlanUrl, { headers: this.headers }).pipe(
			map((changePlanRes: any) => {
				if (changePlanRes.length === 0) return { idChangePlan: '' };

				changePlanRes = changePlanRes[0];
				const returnData = {};
				returnData['idChangePlan'] = [changePlanRes.id];
				returnData['description'] = [changePlanRes.description];
				returnData['reason'] = [changePlanRes.reason];
				returnData['impact_during_execution'] = [changePlanRes.impact_during_execution];
				returnData['impact_not_executed'] = [changePlanRes.impact_not_executed];
				returnData['changeStartDate'] = [new ShkDate(new Date(changePlanRes.start_date)).date];
				returnData['changeStartTime'] = [
					new ShkDate(new Date(changePlanRes.start_date)).hours + ':' + new ShkDate(new Date(changePlanRes.start_date)).minutes,
				];
				returnData['changeFinishDate'] = [new ShkDate(new Date(changePlanRes.finish_date)).date];
				returnData['changeFinishTime'] = [
					new ShkDate(new Date(changePlanRes.finish_date)).hours + ':' + new ShkDate(new Date(changePlanRes.finish_date)).minutes,
				];
				returnData['responsibles'] = [];
				returnData['preImplement'] = [];
				returnData['implement'] = [];
				returnData['posImplement'] = [];
				returnData['backout'] = [];
				returnData['testing'] = [];

				for (const responsible of changePlanRes.responsible) {
					const temporary = [];
					//tmp.push(responsible.step);
					temporary.push(responsible.responsible, responsible.function, responsible.phone, responsible.email);
					returnData['responsibles'].push([...temporary]);
				}

				for (const task of changePlanRes.preImplementTask) {
					const temporary = [];
					temporary.push(task.description, task.resource, task.tower);
					temporary.push(new ShkDate(new Date(task.start_date)).date);
					temporary.push(
						new ShkDate(new Date(task.start_date)).hours + ':' + new ShkDate(new Date(task.start_date)).minutes,
						task.duration
					);
					temporary.push(task.unavailable);
					returnData['preImplement'].push([...temporary]);
				}

				for (const task of changePlanRes.implementTask) {
					const temporary = [];
					temporary.push(task.description, task.resource, task.tower);
					temporary.push(new ShkDate(new Date(task.start_date)).date);
					temporary.push(
						new ShkDate(new Date(task.start_date)).hours + ':' + new ShkDate(new Date(task.start_date)).minutes,
						task.duration
					);
					temporary.push(task.unavailable);
					returnData['implement'].push([...temporary]);
				}

				for (const task of changePlanRes.posImplementTask) {
					const temporary = [];
					temporary.push(task.description, task.resource, task.tower);
					temporary.push(new ShkDate(new Date(task.start_date)).date);
					temporary.push(
						new ShkDate(new Date(task.start_date)).hours + ':' + new ShkDate(new Date(task.start_date)).minutes,
						task.duration
					);
					temporary.push(task.unavailable);
					returnData['posImplement'].push([...temporary]);
				}

				for (const task of changePlanRes.backoutTask) {
					const temporary = [];
					temporary.push(task.description, task.resource, task.tower, task.duration, task.unavailable);
					returnData['backout'].push([...temporary]);
				}

				for (const task of changePlanRes.testingTask) {
					const temporary = [];
					temporary.push(task.description, task.resource, task.tower);
					temporary.push(new ShkDate(new Date(task.start_date)).date);
					temporary.push(
						new ShkDate(new Date(task.start_date)).hours + ':' + new ShkDate(new Date(task.start_date)).minutes,
						task.duration
					);
					temporary.push(task.unavailable);
					returnData['testing'].push([...temporary]);
				}

				return returnData;
			})
		);
	}

	createChangePlan(idRequest: string, body: any): Observable<any> {
		const changePlanUrl = this.changePlanUrl.replace('{idRequest}', idRequest);
		return this.http.post(changePlanUrl, body, { headers: this.headers });
	}

	updateChangePlan(idRequest: string, body: any): Observable<any> {
		const changePlanUrl = this.changePlanUrl.replace('{idRequest}', idRequest);
		return this.http.put(changePlanUrl, body, { headers: this.headers });
	}

	getRelatedCisChangePlan(idRequest: string): Observable<any> {
		const ciChangePlanUrl = this.ciChangePlanUrl.replace('{idRequest}', idRequest);
		return this.http.get(ciChangePlanUrl, { headers: this.headers });
	}

	createRelatedCisChangePlan(idRequest: string, body: any): Observable<any> {
		const ciChangePlanUrl = this.ciChangePlanUrl.replace('{idRequest}', idRequest);
		return this.http.post(ciChangePlanUrl, body, { headers: this.headers });
	}

	updateRelatedCisChangePlan(idRequest: string, body: any): Observable<any> {
		const ciChangePlanUrl = this.ciChangePlanUrl.replace('{idRequest}', idRequest);
		return this.http.put(ciChangePlanUrl, body, { headers: this.headers });
	}
}
